import { Colors, Icon, Text } from '@amelio/ui-library';

import type { IconProps } from '@amelio/ui-library';

export interface TipGridItem {
    icon: IconProps['name'];
    title: string;
    description: string;
}

interface TipGridContentProps {
    items: TipGridItem[];
}

export const TipGridContent = ({ items }: TipGridContentProps) => {
    return (
        <div className={'grid grid-cols-1 gap-6 md:grid-cols-2'}>
            {items.map((item) => (
                <div
                    key={item.title}
                    className={
                        'flex items-start gap-4 rounded-lg border border-slate-200 bg-white !p-4 md:!p-6'
                    }
                >
                    <Icon
                        name={item.icon}
                        size={'md'}
                        color={Colors.PRIMARY}
                        className={'!h-7 !w-7'}
                    />

                    <div className={'space-y-2'}>
                        <Text
                            size={'default'}
                            weight={'semibold'}
                            color={Colors.BASE_600}
                            className={'!text-base'}
                        >
                            {item.title}
                        </Text>

                        <Text
                            size={'small'}
                            color={Colors.BASE_400}
                            className={'!text-sm'}
                        >
                            {item.description}
                        </Text>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TipGridContent;
